document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".fade_in_up");

  if (!elements.length) return;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active");
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.2
  });

  elements.forEach(el => observer.observe(el));
});

(function () {
  var restrictedVendors = ['dior', 'fendi', 'cartier', 'dita'];

  function hideRestrictedInstantSearchPrices(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var items = scope.querySelectorAll('.usf-is-product');

    items.forEach(function (item) {
      var vendor = item.querySelector('.usf-vendor');
      var price = item.querySelector('.usf-price-wrapper');
      if (!vendor || !price) return;

      var vendorName = (vendor.textContent || '').trim().toLowerCase();
      if (restrictedVendors.indexOf(vendorName) !== -1) {
        price.style.setProperty('display', 'none', 'important');
        price.style.setProperty('visibility', 'hidden', 'important');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    hideRestrictedInstantSearchPrices(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            hideRestrictedInstantSearchPrices(node);
          }
        });
      });
      hideRestrictedInstantSearchPrices(document);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
